import React, { useEffect, useState } from "react";
import { Collapse, Checkbox, Row, Col, Spin, Button, Skeleton } from "antd";
import flagSenegal from "../../../assets/images/flag-senegal.png";
import flagMali from "../../../assets/images/flag-Mali.png";
import flagGuinee from "../../../assets/images/flag-Guinea.png";
import flagCI from "../../../assets/images/flag-CI.png";
import flagBurkina from "../../../assets/images/flag-Burkina_Faso.png";
import flagTogo from "../../../assets/images/flag-Togo.png";
import flagCameroune from "../../../assets/images/flag-Cameroune.svg";
import flagBenin from "../../../assets/images/flag-Cameroune.svg";
import flagNigeria from "../../../assets/images/flag-Nigeria.webp";
import flagGhana from "../../../assets/images/flag-Ghana.png";
import flagKenya from "../../../assets/images/flag-Kenya.jpg";
import flagCongo from "../../../assets/images/flag-Congo.png";
import defaultflag from "../../../assets/images/flag-default.webp";

const { Panel } = Collapse;

export const countryInfo = {
  SN: { name: "Sénégal", flag: flagSenegal },
  CI: { name: "Côte d’Ivoire", flag: flagCI },
  ML: { name: "Mali", flag: flagMali },
  GN: { name: "Guinée", flag: flagGuinee },
  BF: { name: "Burkina Faso", flag: flagBurkina },
  TG: { name: "Togo", flag: flagTogo },
  CM: { name: "Cameroun", flag: flagCameroune },
  CD: { name: "RD Congo", flag: flagCongo },
  BJ: { name: "Bénin", flag: flagBenin },
  KE: { name: "Kenya", flag: flagKenya },
  NG: { name: "Nigeria", flag: flagNigeria },
  GH: { name: "Ghana", flag: flagGhana },
};

const PaymentMethodSelector = ({ paymentList = [], value = [], onChange, isLoadingPaym, isErrorPaym, errorPaym }) => {
  const [countryPayments, setCountryPayments] = useState({});
  const [allSelected, setAllSelected] = useState(false);

  useEffect(() => {
    const grouped = {};
    paymentList.forEach(({ country, paymentMethod }) => {
      if (!grouped[country]) grouped[country] = [];
      grouped[country].push(...paymentMethod);
    });
    setCountryPayments(grouped);
  }, [paymentList]);

  useEffect(() => {
    const totalCountries = Object.keys(countryPayments).length;
    const selectedCountries = value.length;
    const allMethodsSelected = Object.entries(countryPayments).every(
      ([country, methods]) =>
        value.find((v) => v.country === country)?.paymentMethods.length ===
        methods.length
    );
    setAllSelected(selectedCountries === totalCountries && allMethodsSelected);
  }, [value, countryPayments]);

  const handleCountryChange = (country, checked) => {
    const methods = countryPayments[country] || [];
    const updated = checked
      ? [...value.filter((v) => v.country !== country), { country, paymentMethods: methods }]
      : value.filter((v) => v.country !== country);
    onChange(updated);
  };

  const handleMethodToggle = (country, method, checked) => {
    const countryBlock = value.find((v) => v.country === country);
    let updated = [...value];

    if (countryBlock) {
      const newMethods = checked
        ? [...countryBlock.paymentMethods, method]
        : countryBlock.paymentMethods.filter((m) => m.id !== method.id);

      if (newMethods.length === 0) {
        updated = updated.filter((v) => v.country !== country);
      } else {
        updated = updated.map((v) =>
          v.country === country ? { ...v, paymentMethods: newMethods } : v
        );
      }
    } else if (checked) {
      updated.push({ country, paymentMethods: [method] });
    }

    onChange(updated);
  };

  const isChecked = (country, method) => {
    return value.some(
      (v) => v.country === country && v.paymentMethods.some((m) => m.id === method.id)
    );
  };

  const isAllChecked = (country) => {
    const all = countryPayments[country] || [];
    return all.length > 0 && all.every((method) => isChecked(country, method));
  };

  const handleSelectAll = () => {
    const allSelected = Object.entries(countryPayments).map(([country, methods]) => ({
      country,
      paymentMethods: methods,
    }));
    onChange(allSelected);
  };

  const handleDeselectAll = () => {
    onChange([]);
  };

  const totalSelectedMethods = value.reduce(
    (acc, cur) => acc + (cur.paymentMethods?.length || 0),
    0
  );

  return (
    <div>
      {isLoadingPaym ? (
        <>
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mb-3">
            <Skeleton.Input active size="small" style={{ width: 200 }} />
            <Skeleton.Button active size="small" />
          </div>

          <Collapse accordion>
            {Array.from({ length: 3 }).map((_, i) => (
              <Panel
                key={i}
                header={
                  <Skeleton active paragraph={false} title={{ width: 200 }} />
                }
              >
                <Row gutter={[8, 8]}>
                  {Array.from({ length: 4 }).map((_, j) => (
                    <Col span={24} md={12} key={j}>
                      <Skeleton
                        active
                        paragraph={false}
                        title={{ width: "80%" }}
                      />
                    </Col>
                  ))}
                </Row>
              </Panel>
            ))}
          </Collapse>
        </>
      ) : isErrorPaym ? (
        <div className="alert alert-danger">
          {errorPaym?.message ||
            errorPaym?.toString() ||
            "Erreur merci de contacter le support"}
        </div>
      ) : (
        <>
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mb-3">
            <strong> Méthodes sélectionnées : {totalSelectedMethods} </strong>

            <div className="d-flex gap-2">
              {!allSelected ? (
                <Button type="primary" onClick={handleSelectAll} size="small">
                  Tout sélectionner
                </Button>
              ) : (
                <Button danger onClick={handleDeselectAll} size="small">
                  Tout désélectionner
                </Button>
              )}
            </div>
          </div>

          <Collapse accordion>
            {Object.keys(countryPayments).length === 0 ? (
              <div className="text-muted">
                Aucune méthode disponible pour le moment
              </div>
            ) : (
              [...Object.entries(countryPayments)]
                .sort(([a], [b]) => {
                  const nameA = countryInfo[a]?.name || a;
                  const nameB = countryInfo[b]?.name || b;
                  return nameA.localeCompare(nameB);
                })
                .map(([country, methods]) => {
                  const selectedCount =
                    value.find((v) => v.country === country)?.paymentMethods
                      .length || 0;
                  const flag = countryInfo[country]?.flag || defaultflag;
                  const name = countryInfo[country]?.name || country;

                  return (
                    <Panel
                      key={country}
                      header={
                        <div className="d-flex justify-content-between align-items-center w-100">
                          <div className="d-flex align-items-center gap-2">
                            <img
                              src={flag}
                              alt={`Drapeau ${name}`}
                              style={{
                                width: 20,
                                height: 14,
                                objectFit: "cover",
                                borderRadius: 2,
                              }}
                            />
                            <span>
                              {name} ({selectedCount}/{methods.length})
                            </span>
                          </div>
                          <Checkbox
                            checked={isAllChecked(country)}
                            onChange={(e) =>
                              handleCountryChange(country, e.target.checked)
                            }
                          >
                            Tous
                          </Checkbox>
                        </div>
                      }
                    >
                      <Row gutter={[8, 8]}>
                        {methods.map((method) => (
                          <Col span={24} md={12} key={method.id}>
                            <Checkbox
                              checked={isChecked(country, method)}
                              onChange={(e) =>
                                handleMethodToggle(
                                  country,
                                  method,
                                  e.target.checked
                                )
                              }
                            >
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 8,
                                }}
                              >
                                <img
                                  src={method.urlLogo}
                                  alt={method.name}
                                  style={{
                                    width: 15,
                                    height: 15,
                                    objectFit: "contain",
                                    borderRadius: 4,
                                    flexShrink: 0,
                                  }}
                                />
                                <span>{method.name}</span>
                              </span>
                            </Checkbox>
                          </Col>
                        ))}
                      </Row>
                    </Panel>
                  );
                })
            )}
          </Collapse>
        </>
      )}
    </div>
  );
  // return (
  //   <div>
  //     <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mb-3">
  //       <strong> Méthodes sélectionnées : {totalSelectedMethods} </strong>

  //       <div className="d-flex gap-2">
  //         {!allSelected ? (
  //           <Button type="primary" onClick={handleSelectAll} size="small">
  //             Tout sélectionner
  //           </Button>
  //         ) : (
  //           <Button danger onClick={handleDeselectAll} size="small">
  //             Tout désélectionner
  //           </Button>
  //         )}
  //       </div>
  //     </div>

  //     <Collapse accordion>
  //       {[...Object.entries(countryPayments)]
  //         .sort(([a], [b]) => {
  //           const nameA = countryInfo[a]?.name || a;
  //           const nameB = countryInfo[b]?.name || b;
  //           return nameA.localeCompare(nameB);
  //         })
  //         .map(([country, methods]) => {
  //           const selectedCount = value.find((v) => v.country === country)?.paymentMethods.length || 0;
  //           const flag = countryInfo[country]?.flag || defaultflag;
  //           const name = countryInfo[country]?.name || country;

  //           return (
  //             <Panel
  //               header={
  //                 <div className="d-flex justify-content-between align-items-center w-100">
  //                   <div className="d-flex align-items-center gap-2">
  //                     <img src={flag} alt={`Drapeau ${name}`} style={{ width: 20, height: 14, objectFit: "cover", borderRadius: 2 }} />
  //                     <span>{name} ({selectedCount}/{methods.length})</span>
  //                   </div>
  //                   <Checkbox
  //                     checked={isAllChecked(country)}
  //                     onChange={(e) => handleCountryChange(country, e.target.checked)}
  //                   >
  //                     Tous
  //                   </Checkbox>
  //                 </div>
  //               }
  //               key={country}
  //             >
  //               <Row gutter={[8, 8]}>
  //                 {methods.map((method) => (
  //                   <Col span={24} md={12} key={method.id}>
  //                     <Checkbox
  //                       checked={isChecked(country, method)}
  //                       onChange={(e) => handleMethodToggle(country, method, e.target.checked)}
  //                     >
  //                       <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
  //                         <img
  //                           src={method.urlLogo}
  //                           alt={method.name}
  //                           style={{
  //                             width: 15,
  //                             height: 15,
  //                             objectFit: "contain",
  //                             borderRadius: 4,
  //                             flexShrink: 0,
  //                           }}
  //                         />
  //                         <span>{method.name}</span>
  //                       </span>
  //                     </Checkbox>
  //                   </Col>
  //                 ))}
  //               </Row>
  //             </Panel>
  //           );
  //         })}
  //     </Collapse>
  //   </div>
  // );
};

export default PaymentMethodSelector;
